module.exports = "/images/vendor/desiigner-svg/svg/logos/best-in-travel-2021-primary.svg?ebfb39a2959008831ee7aa9a2c3468f1";